import { render, staticRenderFns } from "./OrderCompletedByProvider.vue?vue&type=template&id=f9035020"
import script from "./OrderCompletedByProvider.vue?vue&type=script&lang=js"
export * from "./OrderCompletedByProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports